import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { INavigation } from 'src/app/models/navigation';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { InviteFriendsTextComponent } from 'src/app/shared/components/invite-friends-text/invite-friends-text.component';
import { NAVIGATION_LIST } from 'src/app/shared/constants/navigation-list';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sm-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  version:any = environment.current_version
  navigationList: INavigation[] = [...NAVIGATION_LIST];
  panelState: any = [true, false, false, false, false];
  @Output() closeSidenav = new EventEmitter<void>();
  _apiSubscription: Subscription
  businessListData:any = []
  constructor(private router: Router, private _modelRef:MatDialog, private _apiService: ApiService, private route:ActivatedRoute, private dialog:MatDialog) {
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST){
        this.businessListData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            if(element.default_image){
              
              element.default_image = typeof element.default_image == 'string' ?  JSON.parse(element.default_image) : element.default_image

            }else{
              element.default_image = {
                image_thumb_url:null
              }
            }
           
            this.businessListData.push(element)
          });
        }

      }
    })
   }

  ngOnInit(): void {
    if(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null'){

      this._apiService.getBasicEntityList()
    }

  }
  activeItem: string = 'dashboard'; // Default active item

isActive(hashId: string): boolean {
  const queryParamHash = this.route.snapshot.queryParamMap.get('entityHash');
  const currentUrl = this.router.url;

  const hasCorrectPath = currentUrl.includes('/businesses/details');
  const matchesQueryParam = queryParamHash === hashId;

  return hasCorrectPath && matchesQueryParam;
}

  setActive(item: string): void {
    this.activeItem = item;
  }
  
  openBusinessDetails(item:any){
    if(item.is_owner == 1){
      localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_HASH, item.hash_id);
      this.router.navigate(['/businesses/details'], {queryParams: {entityHash: item.hash_id}})

    }
    else if(item.is_owner == 0){
      if(!item.entitySubscriptionInfo || item.entitySubscriptionInfo == undefined || item.entitySubscriptionInfo == '' || item.entitySubscriptionInfo == 'null'){
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
            width: '500px',
            data : {
              title : 'Access denied!',
              message : 'The paid pack is expired for this business. You cannot access it right now. Ask your employer or owner of this business to recharge now.',
              okbtn : 'Ok',
              cancelbtn : 'Cancel',
              type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
            },
            disableClose : true
          });
      }
      else if(!item.employeeSubscriptionInfo || item.employeeSubscriptionInfo == undefined || item.employeeSubscriptionInfo == '' || item.employeeSubscriptionInfo == 'null'){
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          width: '500px',
          data : {
            title : 'Access denied!',
            message : 'Your employee pack is either invalid or expired. You cannot access the business right now. Ask your employer or owner of this business to recharge now.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
        },
          disableClose : true
        });
      }
      else if(!item.employee_status || item.employee_status != 1){
const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          width: '500px',
          data : {
            title : 'Access denied!',
            message : 'Your employer de-activated your access temporarily. You cannot perform any operation right now. Ask your employer or owner of this business to activate.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
        },
          disableClose : true
        });
      }
      else{
        localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_HASH, item.hash_id);
        this.router.navigate(['/businesses/details'], {queryParams: {entityHash: item.hash_id}})
    
      }
    }

  }
  openInNewTab(routeSegments: string[]): void {
    const urlTree = this.router.createUrlTree(routeSegments);
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');
  }
  openHelpDocument(routeSegments: string[]): void {
    const urlTree = this.router.createUrlTree(routeSegments);
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');
  }

  openprivacypolicy(){
    this.router.navigate(['/privacy-policy']);
  }
  opentos(){
    this.router.navigate(['/terms-of-service']);
  }
  opendownloadapp(){
    this.router.navigate(['/download-app']);
  }

  opencontact(){
    this.router.navigate(['/contact-us']);

  }
  openLink(url: string): void {
    this.closeMenu()
    window.open(url, '_blank');
  }
  opensharefriend(){
    this.router.navigate(['/invite-friends']);

  }

  inviteFriends(){
    this._modelRef.open(InviteFriendsTextComponent, {
      width: '735px',
      data: {
        title: 'Invite Friends',
        ref: this._modelRef
      },
    });
  }

  closeMenu() {
    this.closeSidenav.emit(); // Emit event when a link is clicked
  }
  
  // Usage example


}
